module.exports = __webpack_public_path__ + "img/2018-09-1.b7a2ad97.jpeg";